import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {updateDynamicItemsTab} from "../../../redux/slices/dynamicUiSlice";
import TabGroup from "../../../components/tab/TabGroup";
import CustomTab, {CustomTabRef} from "../../../components/tab/CustomTab";
import CustomIcon from "../../../components/CustomIcon";
import DropdownMenu, {DropdownItem, DropdownItemGroup} from "@atlaskit/dropdown-menu";

const AddItemTabs = () => {


  const activeTab = useSelector((state) => state.dynamicUi.items.activeTab);
  const selectedTab = useSelector((state) => state.dynamicUi.items[activeTab].selected);

  const currentPage = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].meta.page);

  const loading = useSelector((state) => state.dynamicUi.items[activeTab][selectedTab].pageData[currentPage]?.loading) ?? false;





  const tabItems = useSelector((state) => state.dynamicUi.items[activeTab].tabs);
  const dropDownItems = useSelector((state) => state.dynamicUi.items[activeTab].dropdownTabs);


  const dispatch = useDispatch();

  const updateTab = (tab, fromDropDown = false) => {
    if (tab.value !== selectedTab && !loading) {

      dispatch(updateDynamicItemsTab({tab, fromDropDown}))

    }
  };

  return (

    <TabGroup inline={false}>
      {
        tabItems.map((tab, i) =>
          <CustomTab key={`${KEY_PREFIX}${i}`} onClick={() => updateTab(tab)} className="py-2 flex-1"
                     disabled={loading} active={selectedTab === tab.value}>{tab.title ?? tab.value}</CustomTab>)
      }
      {!!dropDownItems.length &&
      <DropdownMenu placement="bottom-end" shouldFlip isLoading={loading}
                    trigger={({triggerRef, isSelected, testId, ...props}) => (
                      <CustomTabRef ref={triggerRef} {...props} active={isSelected} className="flex items-center px-3">
                        <CustomIcon icon="more_horiz" size="xl"
                                    className='cursor-pointer leading-7'/>
                      </CustomTabRef>
                    )}
      >
        <DropdownItemGroup>
          {
            dropDownItems.map((item, i) =>
              <DropdownItem key={`${KEY_PREFIX_DROPDOWN}${i}`} onClick={() => updateTab(item, true)}>
                {item.title ?? item.value}
              </DropdownItem>)
          }

        </DropdownItemGroup>
      </DropdownMenu>
      }

    </TabGroup>
  );
};

export default React.memo(AddItemTabs);

const KEY_PREFIX = "dynamic_item_all_tabs";
const KEY_PREFIX_DROPDOWN = "dynamic_item_all_dropdowns";

